import {CartProduct} from "../types";
import {updateProductCartQuantity} from "./updateProductCartQuantity";

export function triggerCartLogin(
    notification: string,
    inputRef: React.RefObject<HTMLInputElement>,
    product: CartProduct,
    products: CartProduct[],
    setProducts: (products: CartProduct[]) => void
): void {
    const loginButton = document.querySelector('#login-button') as HTMLElement;
    const modalNotificationContainer = document.querySelector('.login-form .form-notification') as HTMLElement;

    updateProductCartQuantity(products, product.id, 0, setProducts);

    inputRef.current!.value = '';

    loginButton.click();
    modalNotificationContainer.innerHTML = '<div class="form-success" >\n' +
        '                \n' +
        '                <span>' + notification + '</span>\n' +
        '            </div>';
}
